module.exports = __webpack_public_path__ + "img/lanqius.7de6e6bf.png";